import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Grid,
  Paper,
  Input,
  Button,
  InputLabel,
  Typography,
  FormControl,
} from '@material-ui/core/';
import { isEmpty } from 'lodash';

const styles = {
  root: {
    padding: 20,
  },
  textField: {
    marginBottom: 20,
  },
};

class Login extends PureComponent {
  constructor() {
    super();

    this.state = {
      username: '',
      password: '',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange({ target: { name, value } }) {
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { username, password } = this.state;
    this.props.login(username, password);
  }

  render() {
    const { classes, error } = this.props;

    return (
      <Paper className={classes.root} elevation={4}>
        <form onSubmit={this.handleSubmit}>
          <FormControl fullWidth className={classes.textField}>
            <InputLabel>Usuario</InputLabel>
            <Input
              required
              autoFocus
              name="username"
              type="text"
              error={!isEmpty(error)}
              onChange={this.handleChange}
            />
          </FormControl>
          <FormControl fullWidth className={classes.textField}>
            <InputLabel>Password</InputLabel>
            <Input
              required
              type="password"
              name="password"
              error={!isEmpty(error)}
              onChange={this.handleChange}
            />
          </FormControl>
          { (error.error || error.message) &&
            <Typography align="center" className={classes.textField} component="p">
              {error.error || error.message}
            </Typography> }
          <Grid container justify="center">
            <Grid item>
              <Button type="submit" variant="contained" color="primary">
                Iniciar Sesión
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    );
  }
}

export default withStyles(styles)(Login);

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  error: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Login.js